import { useEffect, useState } from "react";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { DecisionSwal } from "Utils/Utils/DecisionSwal";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { CierresMensualesProduccionApi } from "../../../api/CierresMensualesProduccionApi";
import { usePadresProductoTerminado } from "../../../../hooks/usePadresProductoTerminado";

const STORAGE_KEY = "cierres_mensuales_produccion_state";

// Cierres ya registrados. El detalle de cada uno se ve en su propia pantalla
export const useCierresMensualesProduccion = () => {
    const { getCierres, eliminarCierre, cargando } =
        CierresMensualesProduccionApi();

    const estadoGuardado = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtrosGuardados = estadoGuardado.filtros || {};

    const [cierres, setCierres] = useState([]);
    const [cantidadResultados, setCantidadResultados] = useState(0);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        estadoGuardado.pagina || 1,
    );
    const [padreProductoTerminadoFiltro, setPadreProductoTerminadoFiltro] =
        useState(filtrosGuardados.padre_producto_terminado || null);

    const loadPadresProductoTerminado = usePadresProductoTerminado();

    const GetCierres = async () => {
        try {
            const params = { page: paginaSeleccionada };

            if (padreProductoTerminadoFiltro) {
                params.padre_producto_terminado_id =
                    padreProductoTerminadoFiltro.id;
            }

            const data = await getCierres(params);

            setCierres((data && data.results) || []);
            setCantidadResultados((data && data.count) || 0);
        } catch (error) {
            NotificationManager.error(
                getErrorFromResponse(
                    error,
                    "Error al obtener los cierres registrados",
                ),
                "Error",
                3000,
            );

            setCierres([]);
            setCantidadResultados(0);
        }
    };

    useEffect(() => {
        GetCierres();
    }, [paginaSeleccionada, padreProductoTerminadoFiltro]);

    useEffect(() => {
        sessionStorage.setItem(
            STORAGE_KEY,
            JSON.stringify({
                filtros: {
                    padre_producto_terminado: padreProductoTerminadoFiltro,
                },
                pagina: paginaSeleccionada,
            }),
        );
    }, [paginaSeleccionada, padreProductoTerminadoFiltro]);

    // al cambiar el filtro se vuelve a la primera página
    const CambiarPadreProductoTerminadoFiltro = (padreProductoTerminado) => {
        setPadreProductoTerminadoFiltro(padreProductoTerminado);
        setPaginaSeleccionada(1);
    };

    // Solo el último cierre de cada producto padre trae esta acción. Al
    // eliminarlo, su tramo vuelve a quedar libre y el anterior pasa a ser el
    // último
    const EliminarCierre = (cierre) => {
        DecisionSwal(
            `Se eliminará el cierre de ${cierre.padre_producto_terminado_nombre} ` +
                `con corte al ${moment(cierre.fecha_corte).format(
                    "DD/MM/YYYY",
                )}. Sus semanas y periodos de almacén quedarán disponibles para ` +
                "modificarse y cerrarse nuevamente, y se eliminarán las " +
                "diferencias acopio ingresadas manualmente en esos periodos. " +
                "¿Desea eliminarlo?",
            "Sí, eliminar",
            "Cancelar",
            () => _eliminarCierre(cierre),
        );
    };

    const _eliminarCierre = async (cierre) => {
        try {
            await eliminarCierre(cierre.id);

            NotificationManager.success(
                "Cierre eliminado correctamente",
                "Éxito",
                3000,
            );

            // si era el único cierre de la página, se regresa a la anterior
            if (cierres.length === 1 && paginaSeleccionada > 1) {
                setPaginaSeleccionada(paginaSeleccionada - 1);
                return;
            }

            GetCierres();
        } catch (error) {
            NotificationManager.error(
                getErrorFromResponse(error, "Error al eliminar el cierre"),
                "Error",
                3000,
            );
        }
    };

    return {
        cierres,

        cantidadResultados,
        paginaSeleccionada,
        setPaginaSeleccionada,

        loadPadresProductoTerminado,
        padreProductoTerminadoFiltro,
        setPadreProductoTerminadoFiltro: CambiarPadreProductoTerminadoFiltro,

        Refrescar: GetCierres,
        EliminarCierre,

        cargando,
    };
};
